import { NotFoundPageRender } from '@collection-platform-frontend/storefront';

import { PageLayout } from '../components/layout/index';

export default NotFoundPageRender({
  PageLayout,
  onHome: () => (window.location.href = '/'),
});
